import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/check-circle.svg")